import React, { type FC, useState } from "react";
import { LuRefreshCw } from "react-icons/lu";
import { useI18next } from "gatsby-plugin-react-i18next";

import { CHAT_ICON_BUTTON } from "@components/chat/chat_helpers";
import { cn } from "@utilities/helper";

/** Re-fetches the conversation list on demand; the icon turns while it runs. */
const ChatRefreshButton: FC<{
  onRefresh: () => Promise<void>;
  className?: string;
}> = ({ onRefresh, className }) => {
  const { t } = useI18next();
  const [isBusy, setBusy] = useState(false);
  return (
    <button
      type="button"
      aria-label={t("chat_refresh")}
      title={t("chat_refresh")}
      disabled={isBusy}
      onClick={() => {
        setBusy(true);
        void onRefresh().finally(() => {
          setBusy(false);
        });
      }}
      className={cn(CHAT_ICON_BUTTON, className)}
    >
      <LuRefreshCw
        className={cn(isBusy && "animate-spin")}
        aria-hidden="true"
      />
    </button>
  );
};

export default ChatRefreshButton;
